/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Nav_Resources_DocsInputs */

const en_better_studio_nav_resources_docs = /** @type {(inputs: Better_Studio_Nav_Resources_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

/**
* | output |
* | --- |
* | "Docs" |
*
* @param {Better_Studio_Nav_Resources_DocsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_nav_resources_docs = /** @type {((inputs?: Better_Studio_Nav_Resources_DocsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Nav_Resources_DocsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_nav_resources_docs(inputs)
});